const REACT_APP_API_PATH_V1 = '/v1';
const APP_NOTIFICATIONS_PATH = `${REACT_APP_API_PATH_V1}/app-notifications`;
const EARNINGS_PATH = `${REACT_APP_API_PATH_V1}/earnings`;
const EARNINGS_SUMMARY_PATH = `${EARNINGS_PATH}/summary`;
const EARNINGS_TRANSACTIONS_PATH = `${EARNINGS_PATH}/transactions`;
const EVENT_STREAM_PATH = `${REACT_APP_API_PATH_V1}/event-stream`;
const SUSTAINABILITY_IMPACT_USER_PATH = `${REACT_APP_API_PATH_V1}/sustainability-impact/user`;
const CONFIGURATION_PATH = `${REACT_APP_API_PATH_V1}/configurations`;
const OFFERS_PATH = `${REACT_APP_API_PATH_V1}/offers`;
const SLEEK_OFFERS_PATH = `${OFFERS_PATH}/v2`;
const SLEEK_PUBLIC_OFFERS_PATH = `${OFFERS_PATH}/v2/public`;
const SLEEK_OFFER_AFFILIATE_URL_PATH_PARAM = ':offerId';
const SLEEK_OFFER_AFFILIATE_URL_PATH = `${SLEEK_OFFERS_PATH}/activate/${SLEEK_OFFER_AFFILIATE_URL_PATH_PARAM}`;
const PUBLIC_OFFERS_PATH = `${OFFERS_PATH}/public`;
const REWARDS_PATH = `${REACT_APP_API_PATH_V1}/rewards`;
const REWARDS_OFFER_PATH = `${REWARDS_PATH}/offer`;
const REWARDS_PAID_PLACEMENTS_PATH = `${REWARDS_PATH}/paid-placements`;
const REWARDS_USER_PATH = `${REACT_APP_API_PATH_V1}/rewards/user`;
const PERKS_USER_PATH = `${REACT_APP_API_PATH_V1}/perks`;
const GIFT_CARDS_PATH = `${REACT_APP_API_PATH_V1}/gift-cards`;
const GIFT_CARDS_BRANDS_PATH = `${GIFT_CARDS_PATH}/brands`;
const GIFT_CARDS_BRANDS_OFFER_PATH = `${GIFT_CARDS_BRANDS_PATH}/offer`;
const BRAND_ID_PARAM = ':brandId';
const GIFT_CARDS_BRAND_PATH = `${GIFT_CARDS_PATH}/brands/${BRAND_ID_PARAM}`;
const GIFT_CARDS_CATEGORIES_PATH = `${GIFT_CARDS_PATH}/categories`;
const GIFT_CARDS_BRAND_SEARCH_PATH = `${GIFT_CARDS_PATH}/brands/search`;
const GIFT_CARD_ID_PARAM = ':giftCardId';
const GIFT_CARD_BY_UID_PATH = `${GIFT_CARDS_PATH}/${GIFT_CARD_ID_PARAM}`;
const GIFT_CARDS_ISSUE_PATH = `${GIFT_CARDS_PATH}/issue`;
const GIFT_CARDS_USER_PATH = `${GIFT_CARDS_PATH}/user`;
const GIFT_CARDS_USED_PATH = `${GIFT_CARDS_PATH}/${GIFT_CARD_ID_PARAM}/used`;
const USERS_PATH = `${REACT_APP_API_PATH_V1}/users`;
const USERS_MILESTONE_PROGRESS_PATH = `${USERS_PATH}/milestone-progress`;
const USERS_ADDRESSES_PATH = `${USERS_PATH}/addresses`;
const USERS_MEMBERSHIP_ADDRESSES_PATH = `${USERS_PATH}/membership-addresses`;
const USERS_CREATE_ADDRESS_PATH = `${USERS_PATH}/create-address`;
const ADDRESS_UID_PARAM = ':addressUid';
const USERS_UPDATE_ADDRESS_PATH = `${USERS_ADDRESSES_PATH}/${ADDRESS_UID_PARAM}`;
const USERS_STATUS_PATH = `${USERS_PATH}/status`;
const REWARD_ID_PARAM = ':rewardId';
const REWARD_PATH = `${REWARDS_PATH}/${REWARD_ID_PARAM}`;
const REWARDS_CLAIM_PATH = `${REWARDS_PATH}/${REWARD_ID_PARAM}/claim`;
const REWARDS_USED_PATH = `${REWARDS_PATH}/${REWARD_ID_PARAM}/used`;
const REWARDS_CODE_BY_UID_AND_BY_USER = `${REWARDS_PATH}/user/reward-code/${REWARD_ID_PARAM}`;
const TBB_LIST_BY_USER = `${REACT_APP_API_PATH_V1}/take-back-bags`;
const STORES_PATH = '/stores';
const STORE_ID_PARAM = ':storeId';
const STORE_PATH = `${STORES_PATH}/${STORE_ID_PARAM}`;
const REWARDS_STORE_PATH = `${REWARDS_PATH}/store/${STORE_ID_PARAM}`;
const REWARDS_STORE_PATH_PUBLIC = `${REWARDS_STORE_PATH}/public`;
const REWARDS_STORES_PATH = `${REWARDS_PATH}/stores`;
const SHOPIFY_STORE_PARAM = ':shop';
const DISCOUNT_CODE_ID_PARAM = ':discountCodeId';
const CLOSET_CASH_DISCOUNT_CODES_PATH = `${REACT_APP_API_PATH_V1}/shop/${SHOPIFY_STORE_PARAM}/discount-codes`;
const CLOSET_CASH_DISCOUNT_CODE_CLAIM_PATH = `${CLOSET_CASH_DISCOUNT_CODES_PATH}/${DISCOUNT_CODE_ID_PARAM}/claim`;
const REDEMPTION_CODE_PARAM = ':redemptionCode';
const SHIPPING_LABELS_PATH = '/shipping-labels';
const SHIPMENTS_TRACKERS_PATH = `${REACT_APP_API_PATH_V1}/shipments/trackers`;
const REGENERATION_SHIPPING_LABEL_PATH = `${REACT_APP_API_PATH_V1}${SHIPPING_LABELS_PATH}/regenerate/${REDEMPTION_CODE_PARAM}`;
const TOTAL_IMPACT_PATH = `${REACT_APP_API_PATH_V1}/impact-dashboard/store/${STORE_ID_PARAM}/totalImpact`;
const CATEGORIES_PATH = `${REACT_APP_API_PATH_V1}/categories`;
const EARNINGS_CAROUSEL_PATH = `${EARNINGS_PATH}/carousel`;
const SEND_SIGN_IN_EMAIL_LINK_PATH = `${REACT_APP_API_PATH_V1}/auth/send-sign-in-email-link`;
const AUTH_ACTIONS_PATH = `${REACT_APP_API_PATH_V1}/auth/actions`;
const SEND_EMAIL_VERIFICATION_PATH = `${AUTH_ACTIONS_PATH}/send-verification-email`;
const SEND_PASSWORD_RESET_EMAIL_PATH = `${AUTH_ACTIONS_PATH}/send-reset-password`;
const FORCE_RESET_PASSWORD_PATH = `${AUTH_ACTIONS_PATH}/force-reset-password`;
const SHIPPING_PROVIDERS_PATH = `${REACT_APP_API_PATH_V1}/shipping-providers`;
const SUBSCRIBE_PATH = `${REACT_APP_API_PATH_V1}/marketing/subscribeStatus`;
const REDEMPTIONS_PATH = '/redemptions';
const AUTH_USERS_PATH = `${REACT_APP_API_PATH_V1}/auth/users`;
const SIMILAR_AND_TRENDING_REWARDS_PATH = `${REACT_APP_API_PATH_V1}/trending/rewards`;
const FEATURED_REWARDS_PATH = `${REWARDS_PATH}/featured`;
const SYSTEM_MESSAGES_PATH = `${REACT_APP_API_PATH_V1}/system-messages`;
const PAYMENTS_PATH = `${REACT_APP_API_PATH_V1}/payments`;
const PAYMENTS_CREATE_PAY_ON_REG_CHECKOUT_SESSION_PATH = `${PAYMENTS_PATH}/${REDEMPTION_CODE_PARAM}/create-checkout-session`;
const PAYMENTS_CREATE_PAYMENT_INTENT_PATH = `${PAYMENTS_PATH}/${REDEMPTION_CODE_PARAM}/create-payment-intent`;
const PAYMENTS_STATUS_PATH = `${PAYMENTS_PATH}/${REDEMPTION_CODE_PARAM}/status`;
const PAYMENTS_CREATE_SETUP_INTENT_PATH = `${PAYMENTS_PATH}/create-setup-intent`;
const REWARDS_EXCLUSIVE_PATH = `${REWARDS_PATH}/exclusive/${REDEMPTION_CODE_PARAM}`;
const REWARDS_USER_EXCLUSIVE_DEALS_PATH = `${REACT_APP_API_PATH_V1}/users/exclusive`;
const EVENTS_PATH = `${REACT_APP_API_PATH_V1}/events`;
const EVENT_ID_PARAM = ':eventId';
const EVENT_TICKETS_PATH = `${EVENTS_PATH}/${EVENT_ID_PARAM}/tickets`;
const EVENT_TICKETS_COUNT_PATH = `${EVENT_TICKETS_PATH}/count`;
const EVENT_TICKETS_CLAIM_PATH = `${EVENT_TICKETS_PATH}/claim`;
const BROWN_UNIVERSITY_EVENT_ID = '7a2b5e7b-10c8-45be-9555-e67ff4ae477f';
const MARKETING_PATH = `${REACT_APP_API_PATH_V1}/marketing`;
const MARKETING_ITERABLE_SUBSCRIPTION_PATH = `${MARKETING_PATH}/conferenceSubscribe`;
const SUBSCRIPTIONS_PATH = `${REACT_APP_API_PATH_V1}/subscriptions`;
const SUBSCRIPTIONS_CLAIM_TBB_PATH = `${SUBSCRIPTIONS_PATH}/claim-tbb`;
const SUBSCRIPTIONS_CREATE_CHECKOUT_SESSION_PATH = `${SUBSCRIPTIONS_PATH}/create-checkout-session`;
const SUBSCRIPTIONS_CREATE_ELEMENTS_INTENT_PATH = `${SUBSCRIPTIONS_PATH}/create-elements-intent`;
const SUBSCRIPTIONS_FINALIZE_ELEMENTS_PAYMENT_PATH = `${SUBSCRIPTIONS_PATH}/finalize-elements-payment`;
const SUBSCRIPTIONS_ESTIMATE_TAX_PATH = `${SUBSCRIPTIONS_PATH}/estimate-tax`;
const SUBSCRIPTIONS_ORDERS_PATH = `${SUBSCRIPTIONS_PATH}/orders`;
const SUBSCRIPTION_ID_PARAM = ':subscriptionId';
const SUBSCRIPTIONS_CANCEL_PATH = `${SUBSCRIPTIONS_PATH}/${SUBSCRIPTION_ID_PARAM}/cancel`;
const SUBSCRIPTIONS_UPDATE_PATH = `${SUBSCRIPTIONS_PATH}/${SUBSCRIPTION_ID_PARAM}/update`;
const CHECKOUT_SESSION_ID_PARAM = ':checkoutSessionId';
const SUBSCRIPTIONS_CHECKOUT_SESSION_PATH = `${SUBSCRIPTIONS_PATH}/checkout-session/${CHECKOUT_SESSION_ID_PARAM}`;
const PAYMENT_INTENT_ID_PARAM = ':paymentIntentId';
const SUBSCRIPTIONS_PAYMENT_INTENT_STATUS_PATH = `${SUBSCRIPTIONS_PATH}/payment-intent/${PAYMENT_INTENT_ID_PARAM}/status`;
const PAYMENTS_ORDER_PATH = `${PAYMENTS_PATH}/order`;
const PAYMENTS_ORDER_CREATE_CHECKOUT_SESSION_PATH = `${PAYMENTS_ORDER_PATH}/create-checkout-session`;
const PAYMENTS_ORDER_CHECKOUT_SESSION_PATH = `${PAYMENTS_ORDER_PATH}/checkout-session/${CHECKOUT_SESSION_ID_PARAM}`;
const MEMBERSHIP_PRODUCTS_PATH = `${REACT_APP_API_PATH_V1}/membership-products`;
const MEMBERSHIP_PRODUCTS_PRICES_PATH = `${MEMBERSHIP_PRODUCTS_PATH}/prices`;
const MEMBERSHIP_VALIDATE_SHIPPING_PATH = `${MEMBERSHIP_PRODUCTS_PATH}/validate-shipping`;
const SAVED_MONEY_PATH = `${SUBSCRIPTIONS_PATH}/saved-money`;
const FEDEX_LOCATIONS_PATH = `${REACT_APP_API_PATH_V1}/shipping-locations/fedex`;
const SUBSCRIPTIONS_PLANS_PATH = `${SUBSCRIPTIONS_PATH}/current-membership-prices`;
const SUBSCRIPTIONS_EMAIL_ELIGIBILITY_PATH = `${SUBSCRIPTIONS_PATH}/email-eligibility`;
const AUTH_PHONE_VERIFY_PATH = `${REACT_APP_API_PATH_V1}/auth/phone/verify`;
const AUTH_PHONE_PATH = `${REACT_APP_API_PATH_V1}/auth/phone`;
const AUTH_PHONE_LOGIN_PATH = `${REACT_APP_API_PATH_V1}/auth/phone/login`;
const AUTH_MFA_ENABLE_PATH = `${REACT_APP_API_PATH_V1}/auth/mfa/enable`;

const EVENT_STREAM_EVENT_TYPES = {
  USER_REGISTERED: 'user-registered',
  USER_LOGGED_IN: 'user-logged-in',
  USER_LOGGED_IN_WF_EXTENSION: 'user-logged-in-wf-extension',
  USER_LAST_VISIT: 'user-last-visit',
};

const EVENT_STREAM_APP_TYPES = {
  TRASHIE: 'trashie',
};

const SHOPIFY_STORES = {
  TRASHIE_STORE: 'trashie',
  CLOSET_CASH_STORE: 'closet-cash',
};

const VALIDATE_SHIPPING_TYPES = {
  MEMBERSHIP_ORDER: 'MEMBERSHIP_ORDER',
  ONE_TIME_ORDER: 'ONE_TIME_ORDER',
};

const PROVIDER_TYPES = {
  FEDEX: 'FEDEX',
  HAPPY_RETURNS: 'HAPPY_RETURNS',
};

export {
  APP_NOTIFICATIONS_PATH,
  EARNINGS_SUMMARY_PATH,
  EARNINGS_TRANSACTIONS_PATH,
  EVENT_STREAM_PATH,
  SUSTAINABILITY_IMPACT_USER_PATH,
  EVENT_STREAM_EVENT_TYPES,
  EVENT_STREAM_APP_TYPES,
  CONFIGURATION_PATH,
  OFFERS_PATH,
  SLEEK_OFFERS_PATH,
  SLEEK_OFFER_AFFILIATE_URL_PATH,
  SLEEK_OFFER_AFFILIATE_URL_PATH_PARAM,
  PUBLIC_OFFERS_PATH,
  REWARDS_PATH,
  REWARDS_USER_PATH,
  USERS_ADDRESSES_PATH,
  USERS_STATUS_PATH,
  REWARD_ID_PARAM,
  REWARD_PATH,
  REWARDS_CLAIM_PATH,
  REWARDS_USED_PATH,
  TBB_LIST_BY_USER,
  STORES_PATH,
  STORE_ID_PARAM,
  STORE_PATH,
  REWARDS_STORE_PATH,
  REWARDS_OFFER_PATH,
  REWARDS_PAID_PLACEMENTS_PATH,
  CATEGORIES_PATH,
  REWARDS_CODE_BY_UID_AND_BY_USER,
  CLOSET_CASH_DISCOUNT_CODES_PATH,
  SHOPIFY_STORE_PARAM,
  SHOPIFY_STORES,
  DISCOUNT_CODE_ID_PARAM,
  CLOSET_CASH_DISCOUNT_CODE_CLAIM_PATH,
  REDEMPTION_CODE_PARAM,
  REGENERATION_SHIPPING_LABEL_PATH,
  TOTAL_IMPACT_PATH,
  EARNINGS_CAROUSEL_PATH,
  SEND_SIGN_IN_EMAIL_LINK_PATH,
  SEND_EMAIL_VERIFICATION_PATH,
  SEND_PASSWORD_RESET_EMAIL_PATH,
  FORCE_RESET_PASSWORD_PATH,
  SHIPPING_PROVIDERS_PATH,
  SHIPMENTS_TRACKERS_PATH,
  SUBSCRIBE_PATH,
  REDEMPTIONS_PATH,
  GIFT_CARDS_BRANDS_PATH,
  GIFT_CARDS_BRANDS_OFFER_PATH,
  BRAND_ID_PARAM,
  GIFT_CARDS_BRAND_PATH,
  GIFT_CARDS_CATEGORIES_PATH,
  GIFT_CARDS_BRAND_SEARCH_PATH,
  GIFT_CARD_ID_PARAM,
  GIFT_CARD_BY_UID_PATH,
  GIFT_CARDS_ISSUE_PATH,
  GIFT_CARDS_USER_PATH,
  GIFT_CARDS_USED_PATH,
  AUTH_USERS_PATH,
  SIMILAR_AND_TRENDING_REWARDS_PATH,
  FEATURED_REWARDS_PATH,
  SYSTEM_MESSAGES_PATH,
  PAYMENTS_CREATE_PAY_ON_REG_CHECKOUT_SESSION_PATH,
  PAYMENTS_CREATE_PAYMENT_INTENT_PATH,
  PAYMENTS_STATUS_PATH,
  PAYMENTS_CREATE_SETUP_INTENT_PATH,
  PAYMENTS_ORDER_PATH,
  PAYMENTS_ORDER_CHECKOUT_SESSION_PATH,
  PAYMENTS_ORDER_CREATE_CHECKOUT_SESSION_PATH,
  PERKS_USER_PATH,
  REWARDS_EXCLUSIVE_PATH,
  REWARDS_USER_EXCLUSIVE_DEALS_PATH,
  EVENT_TICKETS_COUNT_PATH,
  EVENT_TICKETS_CLAIM_PATH,
  EVENT_ID_PARAM,
  BROWN_UNIVERSITY_EVENT_ID,
  MARKETING_ITERABLE_SUBSCRIPTION_PATH,
  USERS_PATH,
  USERS_MILESTONE_PROGRESS_PATH,
  USERS_MEMBERSHIP_ADDRESSES_PATH,
  USERS_CREATE_ADDRESS_PATH,
  ADDRESS_UID_PARAM,
  USERS_UPDATE_ADDRESS_PATH,
  SUBSCRIPTIONS_CLAIM_TBB_PATH,
  SUBSCRIPTIONS_CREATE_CHECKOUT_SESSION_PATH,
  SUBSCRIPTIONS_CREATE_ELEMENTS_INTENT_PATH,
  SUBSCRIPTIONS_FINALIZE_ELEMENTS_PAYMENT_PATH,
  SUBSCRIPTIONS_ESTIMATE_TAX_PATH,
  SUBSCRIPTIONS_ORDERS_PATH,
  SUBSCRIPTIONS_PATH,
  SUBSCRIPTION_ID_PARAM,
  SUBSCRIPTIONS_CANCEL_PATH,
  SUBSCRIPTIONS_UPDATE_PATH,
  SUBSCRIPTIONS_CHECKOUT_SESSION_PATH,
  SUBSCRIPTIONS_PAYMENT_INTENT_STATUS_PATH,
  PAYMENT_INTENT_ID_PARAM,
  CHECKOUT_SESSION_ID_PARAM,
  SLEEK_PUBLIC_OFFERS_PATH,
  MEMBERSHIP_PRODUCTS_PRICES_PATH,
  SAVED_MONEY_PATH,
  MEMBERSHIP_VALIDATE_SHIPPING_PATH,
  VALIDATE_SHIPPING_TYPES,
  SUBSCRIPTIONS_PLANS_PATH,
  SUBSCRIPTIONS_EMAIL_ELIGIBILITY_PATH,
  FEDEX_LOCATIONS_PATH,
  REWARDS_STORE_PATH_PUBLIC,
  REWARDS_STORES_PATH,
  PROVIDER_TYPES,
  AUTH_PHONE_VERIFY_PATH,
  AUTH_PHONE_PATH,
  AUTH_PHONE_LOGIN_PATH,
  AUTH_MFA_ENABLE_PATH,
};
